import { Component } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { ToastaService, ToastaConfig, ToastOptions, ToastData } from 'ngx-toasta';

import { AlertService, AlertMessage, MessageSeverity } from '../services/alert.service';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = '会員専用';
  isUserLoggedIn: boolean;

  stickyToasties: number[] = [];

  constructor(private toastaService: ToastaService, private toastaConfig: ToastaConfig,
    private alertService: AlertService, private authService: AuthService, public router: Router) {

    this.toastaConfig.theme = 'bootstrap';
    this.toastaConfig.position = 'top-right';
    this.toastaConfig.limit = 100;
    this.toastaConfig.showClose = true;
  }

  get isVacantBedsReferenceUser(): boolean {
    return this.authService.isVacantBedsReferenceUser;
  }

  ngOnInit() {
    this.isUserLoggedIn = this.authService.isLoggedIn;

    setTimeout(() => {
      if (this.isUserLoggedIn) {
        this.alertService.resetStickyMessage();
      }
    }, 2000);

    this.alertService.getMessageEvent().subscribe(message => this.showToast(message, false));
    this.alertService.getStickyMessageEvent().subscribe(message => this.showToast(message, true));
    this.alertService.getDeleteStickeyMessageEvent().subscribe((message) => this.clearStickeyToast(message));

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        let url = (<NavigationStart>event).url;

        if (url !== url.toLowerCase()) {
          this.router.navigateByUrl((<NavigationStart>event).url.toLowerCase());
        }
      }
    });
  }

  get currentYear(): number {
    return new Date().getUTCFullYear();
  }

  showToast(message: AlertMessage, isSticky: boolean) {

    if (message == null) {
      for (let id of this.stickyToasties.slice(0)) {
        this.toastaService.clear(id);
      }

      this.alertService.lastStickeyMessageId = 0;

      return;
    }

    let toastOptions: ToastOptions = {
      title: message.summary,
      msg: message.detail,
      timeout: isSticky ? 0 : 4000
    };

    if (isSticky) {
      toastOptions.onAdd = (toast: ToastData) => this.stickyToasties.push(toast.id);

      toastOptions.onRemove = (toast: ToastData) => {
        let index = this.stickyToasties.indexOf(toast.id, 0);

        if (index > -1) {
          this.stickyToasties.splice(index, 1);
        }

        toast.onAdd = null;
        toast.onRemove = null;
      };
    }

    switch (message.severity) {
      case MessageSeverity.default: this.toastaService.default(toastOptions); break;
      case MessageSeverity.info: this.toastaService.info(toastOptions); break;
      case MessageSeverity.success: this.toastaService.success(toastOptions); break;
      case MessageSeverity.error: this.toastaService.error(toastOptions); break;
      case MessageSeverity.warn: this.toastaService.warning(toastOptions); break;
      case MessageSeverity.wait: this.toastaService.wait(toastOptions); break;
    }

    if (isSticky) {
      this.alertService.lastStickeyMessageId =
        this.stickyToasties.length > 0 ? this.stickyToasties[this.stickyToasties.length - 1] : 0;   
    }
  }

  clearStickeyToast(messageId : number) {

    if (messageId == 0)
      return;

    for (let id of this.stickyToasties.slice(0)) {
      if (messageId == id) {
        this.toastaService.clear(id);
        return;
      }
    }

    this.alertService.lastStickeyMessageId = 0;
  }
}
